(() => {
  const init = () => {
    const root = document.querySelector('[data-gift-builder]');
    if (!root || root.dataset.ready) return;
    const cfgEl = root.querySelector('[data-gb-config]');
    if (!cfgEl) return;
    root.dataset.ready = '1';
    const cfg = JSON.parse(cfgEl.textContent);
    const lower = s => String(s || '').toLowerCase().trim();
    const csv = s => String(s || '').split(',').map(lower).filter(Boolean);
    const BOX_COLLECTION = cfg[0];
    const BOX_PREFIX = lower(cfg[1]);
    const PACKING = cfg[2] / 100;
    const CM3_PER_G = cfg[3] / 10;
    const MIN_VOL = cfg[4];
    const HIDE_UNKNOWN = cfg[5];
    const EXCLUDED = csv(cfg[6]);
    const LIGHT = csv(cfg[7]);
    const WORDS = csv(cfg[9]);
    const steps = cfg[8].filter(s => s[0]).map((s, i) => ({ i, handle: s[0], heading: s[1], text: s[2], loaded: false, loading: false, failed: false, products: [], shown: 12, type: '', q: '', open: false }));
    const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
    const apos = String.fromCharCode(39);
    const esc = s => { const d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML.split(apos).join('&#39;'); };
    const SWATCH = { 'black': '#222222', 'red': '#b3261e', 'pink': '#f1c4cd', 'baby blue': '#bcd9ee', 'ivory': '#f4efe1', 'white': '#ffffff', 'cream': '#f3ead8', 'kraft': '#b8905f', 'natural': '#cdb891', 'navy': '#1f2a44', 'green': '#4d6b4a', 'gold': '#c2a15a', 'silver': '#c5c7c9', 'grey': '#8d8d8d' };
    const swatchColour = name => SWATCH[lower(name)] || esc(lower(name).split(' ').join(''));
    const boxName = size => (lower(size).slice(-3) === 'box' || lower(size).slice(-6) === 'hamper' ? size : size + ' box');
    const short = s => (String(s).length > 44 ? String(s).slice(0, 42) + '…' : String(s));
    const WARN = '#a8482f';
    /* noBox is the first-step choice to send the items without a gift box: no size limit and no box line in the basket.
       Auro (2026-10-17): sacks = Christmas sacks offered from September to December; sack = the ids chosen (optional, any number). */
    const state = { boxes: [], boxesTried: false, size: '', box: null, noBox: false, items: new Map(), started: false, sacks: [], sack: new Set() };
    const $ = sel => root.querySelector(sel);
    const el = { boxes: $('[data-gb-boxes]'), steps: $('[data-gb-steps]'), chosen: $('[data-gb-chosen]'), total: $('[data-gb-total]'), count: $('[data-gb-count]'), noun: $('[data-gb-noun]'), hint: $('[data-gb-hint]'), cta: $('[data-gb-cta]'), fill: $('[data-gb-fill]'), meterLabel: $('[data-gb-meterlabel]'), summary: $('[data-gb-summary]'), boxHead: $('[data-gb-boxhead]'), fillHead: $('[data-gb-fillhead]') };
    const ctaLabel = el.cta.textContent;
    const ready = () => !!state.box || state.noBox;
    /* Auro: meaning chips, only on builders with data-gb-meanings (section setting "Show meaning filter"). The feed's last
       column lists each product's symbolism_ tags without the prefix, for example "love,new_beginnings". One choice,
       state.meaning ('' = any), applies to every section and to the step-by-step steps in auro-bundle-wizard.liquid. */
    const MEANINGS = root.hasAttribute('data-gb-meanings') ? [['', 'Any meaning'], ['love', 'Love'], ['protection', 'Protection'], ['abundance', 'Abundance'], ['peace', 'Peace'], ['clarity', 'Clarity'], ['confidence', 'Confidence'], ['creativity', 'Creativity'], ['intuition', 'Intuition'], ['new_beginnings', 'New beginnings']] : null;
    state.meaning = '';
    const meaningsOf = s => (typeof s === 'string' && s ? s.split(',').map(lower).filter(Boolean) : []);
    const hasMeaning = p => !MEANINGS || !state.meaning || (p.meanings || []).indexOf(state.meaning) > -1;
    const NO_MEANING = 'Nothing for this meaning here, try another or Any meaning.';

    const feed = async handle => {
      const out = [];
      let page = 1;
      let pages = 1;
      while (page <= pages && page <= 8) {
        const res = await fetch(base + 'collections/' + handle + '?view=gift-feed&page=' + page);
        if (!res.ok) throw new Error('Feed ' + res.status);
        const data = JSON.parse(await res.text());
        pages = data[0];
        data[2].forEach(r => out.push({ id: r[0], title: r[1], handle: r[2], type: r[3] || '', price: r[4], grams: r[5], available: r[6] === 1, img: r[7], variants: r[8], max: typeof r[9] === 'number' ? r[9] : 999, meanings: meaningsOf(r[10]) }));
        page += 1;
      }
      return out;
    };

    const est = p => {
      if (!p.grams) return HIDE_UNKNOWN ? 0 : MIN_VOL * 2;
      let v = Math.max(MIN_VOL, p.grams * CM3_PER_G);
      if (LIGHT.includes(lower(p.type))) v *= 3;
      return Math.round(v);
    };

    /* Sizes written in a product title, for example 80cm or 30x10cm, longest first. Empty when the title gives none. */
    const FLEXIBLE = ['necklace', 'bracelet', 'mala', 'jewel', 'pendulum', 'chain', 'cord', 'garland', 'ribbon', 'string'];
    const sizeOf = p => {
      if (p.dims) return p.dims;
      let best = [];
      const t = lower(p.title).split(' x ').join('x');
      const bendy = FLEXIBLE.some(word => lower(p.type).indexOf(word) > -1 || t.indexOf(word) > -1);
      if (!bendy) {
        ['cm', 'mm'].forEach(unit => {
          let from = 0;
          for (let guard = 0; guard < 12; guard += 1) {
            const at = t.indexOf(unit, from);
            if (at < 0) break;
            from = at + 2;
            let i = at - 1;
            while (i >= 0 && t[i] === ' ') i -= 1;
            const end = i + 1;
            while (i >= 0 && '0123456789.x'.indexOf(t[i]) > -1) i -= 1;
            const nums = t.slice(i + 1, end).split('x').map(parseFloat).filter(n => n > 0).map(n => (unit === 'mm' ? n / 10 : n));
            if (nums.length && Math.max.apply(null, nums) > (best.length ? Math.max.apply(null, best) : 0)) best = nums;
          }
        });
      }
      p.dims = best.sort((a, b) => b - a);
      return p.dims;
    };
    const fitsDims = p => {
      const d = sizeOf(p);
      if (!d.length || !state.box) return true;
      const b = state.box.dims.slice().sort((x, y) => y - x);
      return d.every((n, i) => n <= (i < b.length ? b[i] : b[b.length - 1]));
    };

    const cap = () => (state.noBox ? Infinity : (state.box ? state.box.vol * PACKING : 0));
    const used = () => { let u = 0; state.items.forEach(it => { u += est(it.p) * it.qty; }); return u; };
    const count = () => { let n = 0; state.items.forEach(it => { n += it.qty; }); return n; };
    /* Auro: "contains" rather than "starts with", so "Ivory Flat Pack Gift Box, Small, ..." counts as a box too. */
    const isBox = p => lower(p.title).indexOf(BOX_PREFIX) > -1;
    const blockedWord = p => { const t = lower(p.title); return WORDS.some(w => t.indexOf(w) > -1); };
    const allowed = p => p.available && p.max > 0 && p.variants === 1 && p.price > 0 && est(p) > 0 && !isBox(p) && !EXCLUDED.includes(lower(p.type)) && !blockedWord(p);
    const fitsBox = p => state.noBox || (est(p) <= cap() * 0.7 && fitsDims(p));
    const hasRoom = p => state.noBox || est(p) <= cap() - used() + 0.5;
    const qtyOf = p => (state.items.has(p.id) ? state.items.get(p.id).qty : 0);
    const tooBig = () => { const list = []; if (state.box) state.items.forEach(it => { if (!fitsBox(it.p)) list.push(it); }); return list; };

    /* Two title styles:
       "Ivory Flat Pack Gift Box, Small, 20x18.2x8cm"           (colour, size, dims: the Small / Medium / Large boxes)
       "Flat Pack Gift Box - Hand Box (20x10x20cm) - Black"      (size and dims, then colour: hand boxes and hampers) */
    const COMMA_BOX = /^(.+?) flat pack gift box, ([^,]+), ([\d.]+)x([\d.]+)x([\d.]+)cm$/i;
    const parseBox = p => {
      const comma = COMMA_BOX.exec(String(p.title).trim());
      if (comma) {
        const dims = [Number(comma[3]), Number(comma[4]), Number(comma[5])];
        return Object.assign({}, p, { size: comma[2].trim(), dims, dimLabel: dims.join(' × ') + ' cm', vol: dims[0] * dims[1] * dims[2], colour: comma[1].trim() });
      }
      const parts = p.title.split(' - ');
      if (parts.length < 3) return null;
      const sizePart = parts[1];
      const name = sizePart.split('(')[0].trim();
      const dimText = (sizePart.split('(')[1] || '').split(')')[0].split('cm').join('');
      const dims = dimText.split('x').map(Number).filter(n => n > 0);
      if (dims.length !== 3) return null;
      return Object.assign({}, p, { size: name, dims, dimLabel: dims.join(' × ') + ' cm', vol: dims[0] * dims[1] * dims[2], colour: parts[parts.length - 1].trim() });
    };

    /* Only red, ivory/white, baby blue, pink and black boxes are offered; red is the default where a size has it. The later
       colours are chosen by the shopper, or by a ready-made box that names one (meaning gift boxes); defaultBox below only
       falls back to them when a size has none of red, ivory or white. */
    const BOX_COLOURS = ['red', 'ivory', 'white', 'baby blue', 'pink', 'black'];
    const defaultBox = same => same.find(b => lower(b.colour) === 'red') || same.find(b => lower(b.colour) === 'ivory') || same.find(b => lower(b.colour) === 'white') || same[0];

    /* Auro: optional Christmas sacks under the box choice. Picking one adds it to the bundle as its own basket line. */
    const sackHtml = () => {
      if (!state.sacks.length) return '';
      let html = `<div class='gb-xmas' style='margin-top:2rem;padding:1.6rem;border-radius:1.6rem;background:#f6efe2'><p style='margin:0 0 .4rem;letter-spacing:.2em;text-transform:uppercase;font-size:1.1rem;color:#8a6a2c'>Make it Christmas</p><p style='margin:0 0 1.2rem;font-size:1.4rem'>Add a jute Christmas sack: the box (or the pieces) goes inside. Optional, and it shows as its own item in your basket.</p><div style='display:grid;grid-template-columns:repeat(auto-fill,minmax(14rem,1fr));gap:1rem'>`;
      state.sacks.forEach(s => {
        const on = state.sack.has(s.id);
        html += `<button type='button' class='gb-size' data-sack='${s.id}' aria-pressed='${on}' style='text-align:left'>${s.img ? `<img class='gb-size__img' src='${esc(s.img)}' alt='' width='360' height='360' loading='lazy'>` : ''}<span class='gb-size__info'><span class='gb-size__name'>${esc(s.title.replace(/ jute christmas sack$/i, ''))}</span><span class='gb-size__dims'>Jute Christmas sack</span><span class='gb-size__price'>${on ? 'Added ✓ · ' : ''}${money.format(s.price / 100)}</span></span></button>`;
      });
      return html + `</div></div>`;
    };

    const renderBoxes = () => {
      const sizes = [];
      state.boxes.forEach(b => { if (!sizes.some(s => s.size === b.size)) sizes.push(b); });
      sizes.sort((a, b) => a.vol - b.vol);
      let html = `<div class='gb-sizes'>`;
      html += `<button type='button' class='gb-size gb-size--none' data-nobox aria-pressed='${state.noBox}'><span class='gb-size__img' style='display:flex;align-items:center;justify-content:center;aspect-ratio:1;background:#F0EBE3;color:#3D3D3D;font-size:1.3rem'>No box</span><span class='gb-size__info'><span class='gb-size__name'>No box</span><span class='gb-size__dims'>Items only</span><span class='gb-size__fit'>Choose any items, with no size limit</span><span class='gb-size__price'>${money.format(0)}</span></span></button>`;
      sizes.forEach(s => {
        const same = state.boxes.filter(b => b.size === s.size);
        const from = Math.min.apply(null, same.map(b => b.price));
        const jars = Math.max(1, Math.floor((s.vol * PACKING) / 400));
        const shown = state.box && state.box.size === s.size ? state.box : defaultBox(same);
        const img = shown.img ? String(shown.img).split('width=360').join('width=720') : '';
        const dots = same.map(b => `<i style='background:#cccccc;background:${swatchColour(b.colour)}' title='${esc(b.colour)}'></i>`).join('');
        html += `<button type='button' class='gb-size' data-size='${esc(s.size)}' aria-pressed='${state.size === s.size}'>${img ? `<img class='gb-size__img' src='${esc(img)}' alt='${esc(shown.title)}' width='720' height='720' loading='lazy'>` : ''}<span class='gb-size__info'><span class='gb-size__name'>${esc(s.size)}</span><span class='gb-size__dims'>${esc(s.dimLabel)}</span><span class='gb-size__fit'>Room for about ${jars} jar-sized items</span><span class='gb-size__dots' aria-label='${same.length} colours'>${dots}</span><span class='gb-size__price'>${money.format(from / 100)}</span></span></button>`;
      });
      html += `</div>`;
      if (state.boxesTried && !state.boxes.length) html += `<p class='gb-note gb-note--warn'>We could not load the gift boxes just now. Please refresh the page, or carry on without a box.</p>`;
      if (state.size && state.box) {
        const same = state.boxes.filter(b => b.size === state.size);
        html += `<div class='gb-boxpick'><div><p class='gb-boxpick__label'>Box colour</p><div class='gb-swatches'>`;
        same.forEach(b => { html += `<button type='button' class='gb-swatch' data-box='${b.id}' aria-pressed='${state.box.id === b.id}'><span class='gb-swatch__dot' style='background:#cccccc;background:${swatchColour(b.colour)}'></span>${esc(b.colour)}</button>`; });
        html += `</div><p class='gb-boxpick__name'>${esc(state.box.title)}, ${money.format(state.box.price / 100)}</p></div></div>`;
      }
      html += sackHtml();
      el.boxes.innerHTML = html;
    };

    const listFor = step => step.products.filter(allowed).filter(fitsBox);
    const filtered = step => {
      const q = lower(step.q);
      return listFor(step).filter(p => (!step.type || lower(p.type) === step.type) && (!q || lower(p.title).indexOf(q) > -1) && hasMeaning(p));
    };

    const cardHtml = (p, step) => {
      const n = qtyOf(p);
      const room = hasRoom(p);
      const atMax = n >= p.max;
      let actions;
      if (n > 0) actions = `<div class='gb-stepper'><button type='button' data-minus aria-label='Remove one'>−</button><span role='status' aria-live='polite'>${n}</span><button type='button' data-plus aria-label='Add one'${room && !atMax ? '' : ' disabled'}>+</button></div>${atMax ? `<span style='display:block;margin-top:.5rem;font-size:1.1rem;text-align:center;color:${WARN}'>Only ${p.max} in stock</span>` : ''}`;
      else if (!room) actions = `<button type='button' class='gb-add' disabled>No room left</button>`;
      else actions = `<button type='button' class='gb-add' data-add>Add</button>`;
      return `<div class='gb-card${n > 0 ? ' is-selected' : ''}' data-card data-id='${p.id}' data-step='${step.i}'><button type='button' class='gb-card__media' data-toggle aria-label='Add or remove ${esc(p.title)}'>${p.img ? `<img src='${esc(p.img)}' alt='${esc(p.title)}' width='360' height='360' loading='lazy'>` : ''}<span class='gb-card__tick' aria-hidden='true'>✓</span></button><div class='gb-card__body'><span class='gb-card__title'>${esc(p.title)}</span><span class='gb-card__meta'><span class='gb-card__price'>${money.format(p.price / 100)}</span><a class='gb-card__link' href='${base}products/${esc(p.handle)}' target='_blank' rel='noopener'>Details</a></span></div><div class='gb-card__actions'>${actions}</div></div>`;
    };

    const renderGrid = step => {
      const wrap = root.querySelector(`[data-dept='${step.i}'] [data-grid-wrap]`);
      if (!wrap) return;
      const list = filtered(step);
      const all = listFor(step);
      const hidden = step.products.filter(allowed).length - all.length;
      let html;
      if (state.noBox) html = `<p class='gb-tools__count'>${list.length} of ${all.length} items.</p>`;
      else html = `<p class='gb-tools__count'>${list.length} of ${all.length} items that fit the ${esc(boxName(state.box.size))}${hidden > 0 ? `. ${hidden} larger items are hidden; choose a bigger box to see them` : ''}.</p>`;
      if (!list.length && MEANINGS && state.meaning) html += `<p class='gb-note'>${NO_MEANING}</p>`;
      else if (!list.length) html += `<p class='gb-note'>${state.noBox ?'Nothing here matches. Try a different search.' : 'Nothing here matches. Try a different search or a larger box.'}</p>`;
      html += `<div class='gb-grid'>` + list.slice(0, step.shown).map(p => cardHtml(p, step)).join('') + `</div>`;
      if (list.length > step.shown) html += `<button type='button' class='gb-more' data-more>Show more (${list.length - step.shown} left)</button>`;
      wrap.innerHTML = html;
    };

    const renderBody = step => {
      const body = root.querySelector(`[data-dept='${step.i}'] [data-body]`);
      if (!body) return;
      if (!ready()) { body.innerHTML = `<p class='gb-note'>Choose a box, or No box, first. This section will then show what you can add.</p>`; return; }
      if (step.failed) { body.innerHTML = `<p class='gb-note gb-note--warn'>We could not load this section just now. Please refresh the page.</p>`; return; }
      if (!step.loaded) { body.innerHTML = `<p class='gb-note'>Loading…</p>`; return; }
      const types = {};
      listFor(step).forEach(p => { const t = p.type || 'Other'; types[t] = (types[t] || 0) + 1; });
      const names = Object.keys(types).sort((a, b) => types[b] - types[a]);
      if (step.type && !names.some(t => lower(t) === step.type)) step.type = '';
      let html = `<div class='gb-tools'><input type='search' data-q value='${esc(step.q)}' placeholder='Search ${esc(step.heading)}' aria-label='Search ${esc(step.heading)}'>`;
      if (names.length > 1) html += `<select data-type aria-label='Filter by type'><option value=''>All types</option>` + names.map(t => `<option value='${esc(lower(t))}'${step.type === lower(t) ? ' selected' : ''}>${esc(t)} (${types[t]})</option>`).join('') + `</select>`;
      html += `</div>`;
      if (MEANINGS) html += `<div class='gb-meanings' role='group' aria-label='Filter by meaning'>` + MEANINGS.map(m => `<button type='button' class='gb-meaning' data-gb-meaning='${m[0]}' aria-pressed='${state.meaning === m[0]}'>${m[1]}</button>`).join('') + `</div>`;
      html += `<div data-grid-wrap></div>`;
      body.innerHTML = html;
      renderGrid(step);
    };

    const renderSteps = () => {
      el.steps.innerHTML = steps.map(step => `<section class='gb-dept' data-dept='${step.i}'><button type='button' class='gb-dept__head' data-toggle-step aria-expanded='false'><span class='gb-dept__titles'><span class='gb-dept__title'>${esc(step.heading)}</span><span class='gb-dept__text'>${esc(step.text)}</span></span><span class='gb-dept__status' data-status>None yet</span><span class='gb-dept__chev' aria-hidden='true'>+</span></button><div class='gb-dept__body' data-body hidden></div></section>`).join('');
    };

    const loadStep = async step => {
      if (step.loaded || step.loading) return;
      step.loading = true;
      try { step.products = await feed(step.handle); step.loaded = true; } catch (error) { step.failed = true; }
      step.loading = false;
      if (step.open) renderBody(step);
    };

    const setOpen = (step, open) => {
      step.open = open;
      const sec = root.querySelector(`[data-dept='${step.i}']`);
      if (!sec) return;
      sec.classList.toggle('is-open', open);
      sec.querySelector('[data-toggle-step]').setAttribute('aria-expanded', String(open));
      sec.querySelector('[data-body]').hidden = !open;
      if (open) { renderBody(step); if (ready()) loadStep(step); }
    };

    const refresh = () => {
      const n = count();
      let sum = state.box ? state.box.price : 0;
      state.sacks.forEach(s => { if (state.sack.has(s.id)) sum += s.price; });
      state.items.forEach(it => { sum += it.p.price * it.qty; });
      const c = cap();
      const pct = c && !state.noBox ? Math.round((used() / c) * 100) : 0;
      const big = tooBig();
      const over = pct > 100 || big.length > 0;
      el.total.textContent = money.format(sum / 100);
      el.count.textContent = String(n);
      el.noun.textContent = n === 1 ? 'item' : 'items';
      el.fill.style.width = Math.min(100, pct) + '%';
      el.meterLabel.textContent = state.noBox ? 'No box, items only' : (state.box ? state.box.size + (pct > 100 ? ', too full' : ', about ' + pct + '% full') : 'No box chosen yet');
      el.summary.classList.toggle('is-over', over);
      let hint = state.noBox ? 'Your items are ready' : 'Your gift box is ready';
      if (!ready()) hint = 'Start by choosing a box, or No box';
      else if (!n) hint = 'Now add at least one item';
      else if (big.length) hint = short(big[0].p.title) + ' is too large for this box';
      else if (over) hint = 'Your choices need a larger box';
      el.hint.textContent = hint;
      el.cta.setAttribute('aria-disabled', String(!ready() || !n || over));
      if (el.boxHead) el.boxHead.classList.toggle('is-done', ready());
      if (el.fillHead) el.fillHead.classList.toggle('is-done', n > 0);
      steps.forEach(step => {
        let chosen = 0;
        state.items.forEach(it => { if (it.step === step.i) chosen += it.qty; });
        const sec = root.querySelector(`[data-dept='${step.i}']`);
        if (!sec) return;
        sec.classList.toggle('has-items', chosen > 0);
        sec.querySelector('[data-status]').textContent = chosen > 0 ? chosen + ' chosen' : 'None yet';
      });
      if (n > 0) {
        let chips = '';
        state.items.forEach(it => {
          const bad = big.indexOf(it) > -1;
          chips += `<span class='gb-chip'${bad ? ` style='border-color:${WARN};color:${WARN}'` : ''}>${esc(it.p.title)}${it.qty > 1 ? ' × ' + it.qty : ''}${bad ? ' (too large for this box)' : ''}<button type='button' data-remove='${it.p.id}' aria-label='Remove ${esc(it.p.title)}'>×</button></span>`;
        });
        el.chosen.innerHTML = `<h3 class='gb-chosen__title'>${state.noBox ? 'Your items' : 'In your box'}</h3><div class='gb-chips'>${chips}</div>`;
        el.chosen.hidden = false;
      } else { el.chosen.hidden = true; el.chosen.innerHTML = ''; }
    };

    const redrawOpen = full => { steps.forEach(step => { if (step.open) { if (full) renderBody(step); else renderGrid(step); } }); };

    const setQty = (p, stepIndex, value) => {
      const current = qtyOf(p);
      const n = Math.max(0, value);
      if (n > current && (!hasRoom(p) || n > p.max)) return;
      const existing = state.items.get(p.id);
      if (n === 0) state.items.delete(p.id); else state.items.set(p.id, { p, qty: n, step: existing ? existing.step : stepIndex });
      redrawOpen(false);
      refresh();
    };

    /* Pass a box to pack into it, or null for the No box option. */
    const chooseBox = box => {
      state.box = box;
      state.size = box ? box.size : '';
      state.noBox = !box;
      renderBoxes();
      if (!state.started) { state.started = true; if (steps[0]) setOpen(steps[0], true); }
      steps.forEach(step => { if (step.open) { renderBody(step); loadStep(step); } });
      refresh();
    };

    const resetCta = () => { el.cta.textContent = ctaLabel; el.cta.disabled = false; };

    const submit = async () => {
      if (el.cta.disabled) return;
      if (el.cta.getAttribute('aria-disabled') === 'true') {
        const target = !ready() ? el.boxes : (tooBig().length || count() ? el.chosen : el.steps);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      /* Auro: hidden line properties replace the old visible "Gift box: Build 123456" tag. The basket groups lines by _bundle_id
         and shows "<_bundle> bundle"; underscore keys stay hidden in the basket and at checkout but are kept on the order. */
      const bundleId = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      const namedAs = root.dataset.gbBundleName || 'Gift box';
      const bundleName = state.noBox && namedAs === 'Gift box' ? 'Gift set' : namedAs;
      const props = () => ({ _bundle_id: bundleId, _bundle: bundleName });
      const items = state.box ? [{ id: state.box.id, quantity: 1, properties: props() }] : [];
      state.items.forEach(it => items.push({ id: it.p.id, quantity: it.qty, properties: props() }));
      state.sacks.forEach(s => { if (state.sack.has(s.id)) items.push({ id: s.id, quantity: 1, properties: props() }); });
      /* Auro: names for bundle-cart-guard.js, so a stock message can say which item is short. */
      const titles = {};
      if (state.box) titles[state.box.id] = state.box.title;
      state.items.forEach(it => { titles[it.p.id] = it.p.title; });
      state.sacks.forEach(s => { if (state.sack.has(s.id)) titles[s.id] = s.title; });
      window.__auroBundleTitles = titles;
      el.cta.textContent = 'Adding…';
      el.cta.disabled = true;
      let message = '';
      try {
        const response = await fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        if (response.ok) { window.location.href = base + 'cart'; return; }
        try { const data = await response.json(); message = data.description || data.message || ''; } catch (error) { message = ''; }
        /* Auro: bundle-cart-guard.js has already put the basket back and written which item is short into the hint, so keep its words. */
        if (message === 'Bundle not added') { resetCta(); return; }
        let partial = false;
        try {
          const cart = await fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
          partial = cart.items.some(line => line.properties && line.properties._bundle_id === bundleId);
        } catch (error) { partial = false; }
        if (partial) {
          el.hint.textContent = 'Some items were not available in the quantity you chose. Taking you to your basket to check.';
          window.setTimeout(() => { window.location.href = base + 'cart'; }, 2800);
          return;
        }
      } catch (error) { message = ''; }
      el.hint.textContent = message || 'We could not add your choices just now. Please try again.';
      resetCta();
    };

    root.addEventListener('click', event => {
      const t = event.target;
      if (t.closest('[data-nobox]')) { chooseBox(null); return; }
      const sizeBtn = t.closest('[data-size]');
      if (sizeBtn) {
        const same = state.boxes.filter(b => b.size === sizeBtn.dataset.size);
        const keep = state.box ? same.find(b => b.colour === state.box.colour) : null;
        chooseBox(keep || defaultBox(same));
        return;
      }
      const sackBtn = t.closest('[data-sack]');
      if (sackBtn) {
        const id = Number(sackBtn.dataset.sack);
        if (state.sack.has(id)) state.sack.delete(id); else state.sack.add(id);
        renderBoxes();
        refresh();
        return;
      }
      const boxBtn = t.closest('[data-box]');
      if (boxBtn) { const box = state.boxes.find(b => String(b.id) === boxBtn.dataset.box); if (box) chooseBox(box); return; }
      const meaning = t.closest('[data-gb-meaning]');
      if (meaning) {
        state.meaning = meaning.dataset.gbMeaning;
        steps.forEach(step => { step.shown = 12; if (step.open) renderBody(step); });
        return;
      }
      const head = t.closest('[data-toggle-step]');
      if (head) { const step = steps[Number(head.closest('[data-dept]').dataset.dept)]; setOpen(step, !step.open); return; }
      const more = t.closest('[data-more]');
      if (more) { const step = steps[Number(more.closest('[data-dept]').dataset.dept)]; step.shown += 12; renderGrid(step); return; }
      const remove = t.closest('[data-remove]');
      if (remove) { const it = state.items.get(Number(remove.dataset.remove)); if (it) setQty(it.p, it.step, 0); return; }
      if (t.closest('[data-gb-cta]')) { submit(); return; }
      const card = t.closest('[data-card]');
      if (!card) return;
      const step = steps[Number(card.dataset.step)];
      const p = step.products.find(x => x.id === Number(card.dataset.id));
      if (!p) return;
      if (t.closest('[data-plus]')) setQty(p, step.i, qtyOf(p) + 1);
      else if (t.closest('[data-minus]')) setQty(p, step.i, qtyOf(p) - 1);
      else if (t.closest('[data-add]')) setQty(p, step.i, 1);
      else if (t.closest('[data-toggle]')) setQty(p, step.i, qtyOf(p) > 0 ? 0 : 1);
    });

    root.addEventListener('input', event => {
      const q = event.target.closest('[data-q]');
      if (!q) return;
      const step = steps[Number(q.closest('[data-dept]').dataset.dept)];
      step.q = q.value;
      step.shown = 12;
      renderGrid(step);
    });

    root.addEventListener('change', event => {
      const sel = event.target.closest('[data-type]');
      if (!sel) return;
      const step = steps[Number(sel.closest('[data-dept]').dataset.dept)];
      step.type = sel.value;
      step.shown = 12;
      renderGrid(step);
    });

    window.addEventListener('pageshow', event => { if (event.persisted) { resetCta(); refresh(); } });
    /* Auro: after a stock shortfall, bundle-cart-guard.js reports what is really available; lower those picks to match. */
    document.addEventListener('auro:bundle-short', event => {
      const list = (event.detail && event.detail.items) || [];
      list.forEach(row => {
        const it = state.items.get(Number(row.id));
        if (it) setQty(it.p, it.step, Math.min(it.qty, Math.max(0, Number(row.available) || 0)));
      });
    });

    renderSteps();
    refresh();
    renderBoxes();
    feed(BOX_COLLECTION).then(list => {
      state.boxes = list.filter(p => p.available && isBox(p)).map(parseBox).filter(Boolean).filter(b => BOX_COLOURS.includes(lower(b.colour)));
      /* Christmas sacks from September (month 8) to December. */
      state.sacks = new Date().getMonth() >= 8 ? list.filter(p => p.available && lower(p.title).indexOf('christmas sack') > -1) : [];
      state.boxesTried = true;
      renderBoxes();
    }).catch(() => { state.boxes = []; state.boxesTried = true; renderBoxes(); });
    root.giftBuilder = { state, steps, est, cap, used, allowed, fitsBox, sizeOf, refresh, redrawOpen, meanings: MEANINGS, meaningsOf, hasMeaning };
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
